module.exports = __webpack_public_path__ + "img/about-2.e2fb3cf8.png";